import { prefix } from '../module';

export const MEMBERS_VISIBILITY_UPDATED = prefix('MEMBERS_VISIBILITY_UPDATED');
export const MEMBER_ADDED = prefix('MEMBER_ADDED');
export const MEMBER_REMOVED = prefix('MEMBER_REMOVED');
export const MEMBERS_FETCHING = prefix('MEMBERS_FETCHING');
